// localStorage key names. Single source of truth so the storage helpers,
// the barrel, and the language interceptor all agree.

export const ACCESS_TOKEN_KEY = 'accessToken'
export const REFRESH_TOKEN_KEY = 'refreshToken'

export const USER_DETAILS_STORAGE_KEY = 'userDetails'
export const SELECTED_BRANCH_STORAGE_KEY = 'selectedBranch'
// Lightweight summary of the currently-selected branch — just the three
// fields consumers usually want (uuid, numeric id, display name). Use this
// when you don't need the full row (e.g. headers, telemetry, breadcrumb).
export const SELECTED_BRANCH_META_STORAGE_KEY = 'selectedBranchMeta'
// Cached GET /global-settings payload — populated once at login, refreshed
// on every Save in the Global Settings form. The LanguageProvider reads
// `defaultLanguage` from here so the UI boots with the user's language
// without waiting for the network.
export const GLOBAL_SETTINGS_CACHE_STORAGE_KEY = 'globalSettingsCache'
// Local-development override for the /me permission payload. While the
// backend is still rolling out the `permissions[]` field, engineers can
// write a synthetic payload here from DevTools to exercise the dynamic
// sidebar without flipping a server flag. The matcher in
// `src/utils/permission/index.js` prefers this over `userStorage` when
// it is present, then `clearDevOverride()` removes it and the app falls
// back to the real /me snapshot (or the soft-allow default if that's
// empty too).
export const DEV_PERMISSION_OVERRIDE_STORAGE_KEY = 'permissionsOverride'
// Cached payload of GET /guardian-users/permission for the currently
// selected branch. Written on every branch switch (Branch Selection
// screen + sidebar BranchSwitcher). The entry is stamped with the branch
// it belongs to so a stale payload can be told apart from a current one.
export const BRANCH_PERMISSIONS_STORAGE_KEY = 'branchPermissions'
